export const enum LabelLayout {
  SideBySide = 'SideBySide',
  Stacked = 'Stacked',
}

export interface Formatting {
  formatValue: FormatValue;
  formatLabel: FormatLabel;
  labelLayout?: LabelLayout;
}

export interface FormatValue {
  textAlign: TemplateTextAlignType;
  typeSpecific: TypeSpecific;
}

export interface FormatLabel {
  textAlign: TemplateTextAlignType;
}

export const enum TemplateTextAlignType {
  Center = 'Center',
  Left = 'Left',
  Right = 'Right',
}

export type FormattingType = 'None' | 'Text' | 'Number' | 'DateTime';

export interface TypeSpecific {
  formatText: FormatText | null;
  formatNumber: FormatNumber | null;
  formatDateTime: FormatDateTime | null;
}

export interface FormatText {
  showAsTextArea: boolean;
  showPhoneOrMail: boolean;
  showWebLink: boolean;
  specialChars: boolean;
  showAsRichText: boolean;
}

export interface FormatNumber {
  showAsTime: boolean;
  unit: string | null;
  thousandsSeparator: ThousandsSeparator | null;
  mathRound: MathRound | null;
  roundTo: RoundTo | null;
  minValue?: number | null;
  maxValue?: number | null;
}

export const enum ThousandsSeparator {
  Space = 'Space',
  Dot = 'Dot',
  Comma = 'Comma',
}

export const enum MathRound {
  Arithmetic = 'Arithmetic',
  Up = 'Up',
  Down = 'Down',
}

export const enum RoundTo {
  TenThousandths = 'TenThousandths',
  Thousandths = 'Thousandths',
  Hundredths = 'Hundredths',
  Tenths = 'Tenths',
  Dozens = 'Dozens',
  Hundreds = 'Hundreds',
  Thousands = 'Thousands',
}

export interface FormatDateTime {
  variant: TemplateDateTimeType | null;
  minValue: number;
  maxValue: number;
}

export const enum TemplateDateTimeType {
  DateTime = 'DateTime',
  Date = 'Date',
  Time = 'Time',
  MonthYear = 'MonthYear',
}
